import { ICattlePOFeatures } from './interface';
import { getFeatureFlagValue } from '../../common/featureFlags/helpers';

export const cattlePO: ICattlePOFeatures = {
    isBP1146_buypoOrderPriceField: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_BP1146_BUYPO_ORDER_PRICE_FIELD,
    ),
    isBP1246_buypoFilterQuerySync: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_BP1246_BUYPO_FILTER_QUERY_SYNC,
    ),
    isBP1185_SupportButton: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_BP1185_SUPPORT_BUTTON,
    ),
    isBP1063_ShipPOActiveCheckInDropdowns: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_BP1063_SHIPPO_ACTIVE_CHECK_IN_DROPDOWN,
    ),
    isBP1292_Support_backend_implementation: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_BP1292_SUPPORT_BACKEND_IMPLEMENTATION,
    ),
    isBP1283_MissingHdEsthdValidation: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_BP1283_MISSING_HD_ESTHD_VALIDATION,
    ),
    isBP1223_SlideCalculation: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_BP1223_SLIDE_CALCULATION,
    ),
    isBP1299_FixedFormatIssue: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_BP1299_FIXED_FORMAT_ISSUE,
    ),
    isBP1329_BugFixAutocalculateAvgGWPerHd: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_BP1329_BUG_FIX_AUTOCALCULATE_AVG_GW_PER_HD,
    ),
    isBP1336_ViewCattlePOSettingsByAdminRole: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_BP1336_VIEW_CATTLEPO_SETTINGS_BY_ADMIN_ROLE,
    ),
    isBP1189_feedlotDropdown: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_BP1189_FEEDLOT_DROPDOWN,
    ),
};
